<template>
  <SWUpdatePage v-if="'hw' in user"></SWUpdatePage>
  <UpdatePage v-else></UpdatePage>

  
</template>

<script>
// @ is an alias to /src
import UpdatePage from '@/components/UpdatePage.vue'
import SWUpdatePage from '@/components/SWUpdatePage.vue'
import { mapState } from "vuex";

export default {
  components: {
    UpdatePage,
    SWUpdatePage
  },
  computed: {
    ...mapState("auth", ["user"])
  },

}
</script>
